import NodeManager from '../components/NodeManager';
import PathManager from '../components/PathManager';
import Player from '../components/Player';
import Node from '../components/Node';
import { NodeConfigFactory } from '../components/NodeConfigFactory';
import GameScene from './Game';
import { GameObjects } from 'phaser';
import ComputerStrategyFactory from '../components/ComputerStrategyFactory';

export default class GameLevelDev extends GameScene {
    private level: any;

    nodeManager!: NodeManager;
    pathManager!: PathManager;
    keyValueStored = '';
    pathValues!: any[];
    graphics?: Phaser.GameObjects.Graphics;
    bg?: Phaser.GameObjects.Image;
    newNode?: Node;

    constructor() {
        super({key: 'GameLevelDev'});   
    }

    init(): void {
        this.level = {
            'id': 1,
            'description': 'To move your units, click on your town and drag them to another town.',
            'image':'game_image_info_move_units',
            'bg':'bg_rock_03',
            'score': 100,
            'globalPopulationSupply' : -1,
            'players': [],
            'nodes': [],
            'paths': []
        };

        super.init(this.level);

        this.nodeManager = new NodeManager(this, ComputerStrategyFactory.create(''));
        this.pathManager = new PathManager(this);

        this.keyValueStored = '';
        this.pathValues = [];
    }

    preload(): void {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
    }

    create(): void {
        super.create();

        // Graphics
        this.graphics = this.add.graphics();

        // BG
        this.bg = this.add.image(this.width / 2, this.height / 2, 'bg_rock_03').setOrigin(.5);
        this.children.sendToBack(this.bg);

        // Node Inyector
        const buttonData = [
            { frame: 13, y: 150, type: NodeConfigFactory.Types.Town },
            { frame: 3, y: 190, type: NodeConfigFactory.Types.Crop },
            { frame: 18, y: 230, type: NodeConfigFactory.Types.Farm },
            { frame: 7, y: 270, type: NodeConfigFactory.Types.Granary },
            { frame: 6, y: 310, type: NodeConfigFactory.Types.Forest },
            { frame: 8, y: 350, type: NodeConfigFactory.Types.Meadows },
            { frame: 10, y: 390, type: NodeConfigFactory.Types.Mountain },
            { frame: 2, y: 430, type: NodeConfigFactory.Types.Castle },
            { frame: 14, y: 470, type: NodeConfigFactory.Types.Hut },
            { frame: 15, y: 510, type: NodeConfigFactory.Types.Temple },
            { frame: 17, y: 550, type: NodeConfigFactory.Types.Tower },
        ];
        
        buttonData.forEach(data => {
            const button = this.add.sprite(0, data.y, 'node_type', data.frame).setDisplaySize(40, 40).setInteractive();
            this.input.setDraggable(button);
        });

        const neutral = new Player('Neutral', this, Player.neutralType, 0x7c7c7c);
        this.input.on('dragstart', (_pointer: any, gameObject: any, _dragX: number, _dragY: number) => {

            switch (gameObject.frame.name) {
            case 13: this.newNode = new Node(this, (this.nodeManager.all().length+1).toString(), gameObject.x, gameObject.y, neutral, {type: NodeConfigFactory.Types.Town }); break;
            case 3: this.newNode = new Node(this, (this.nodeManager.all().length+1).toString(), gameObject.x, gameObject.y, neutral, {type: NodeConfigFactory.Types.Crop }); break;
            case 18: this.newNode = new Node(this, (this.nodeManager.all().length+1).toString(), gameObject.x, gameObject.y, neutral, {type: NodeConfigFactory.Types.Farm }); break;
            case 7: this.newNode = new Node(this, (this.nodeManager.all().length+1).toString(), gameObject.x, gameObject.y, neutral, {type: NodeConfigFactory.Types.Granary }); break;
            case 6: this.newNode = new Node(this, (this.nodeManager.all().length+1).toString(), gameObject.x, gameObject.y, neutral, {type: NodeConfigFactory.Types.Forest }); break;
            case 8: this.newNode = new Node(this, (this.nodeManager.all().length+1).toString(), gameObject.x, gameObject.y, neutral, {type: NodeConfigFactory.Types.Meadows }); break;
            case 10: this.newNode = new Node(this, (this.nodeManager.all().length+1).toString(), gameObject.x, gameObject.y, neutral, {type: NodeConfigFactory.Types.Mountain }); break;
            case 2: this.newNode = new Node(this, (this.nodeManager.all().length+1).toString(), gameObject.x, gameObject.y, neutral, {type: NodeConfigFactory.Types.Castle }); break;
            case 14: this.newNode = new Node(this, (this.nodeManager.all().length+1).toString(), gameObject.x, gameObject.y, neutral, {type: NodeConfigFactory.Types.Hut }); break;
            case 15: this.newNode = new Node(this, (this.nodeManager.all().length+1).toString(), gameObject.x, gameObject.y, neutral, {type: NodeConfigFactory.Types.Temple }); break;
            case 17: this.newNode = new Node(this, (this.nodeManager.all().length+1).toString(), gameObject.x, gameObject.y, neutral, {type: NodeConfigFactory.Types.Tower }); break;
            default: this.newNode = undefined; break;
            }

            if(this.newNode) {
                this.newNode.create();
                this.nodeManager.all().push(this.newNode);
            }
        });

        this.input.on('drag', (_:any, __:any, dragX: number, dragY: number) => {
            this.newNode?.setPosition(dragX, dragY);
        });

        // Node Generator
        this.add.text(-15, 700, 'O', { fontFamily: 'Georgia, "Goudy Bookletter 1911", Times, serif' })
            .setInteractive({ useHandCursor: true })
            .on('pointerup', () => {
                console.log('generate');

                const level = {nodes:[] as any, paths:[] as any};

                this.nodeManager.all().forEach(node => {
                    level.nodes.push(
                        {'id': node.id, 'x': Math.round(node.x), 'y': Math.round(node.y), 'player': 'Neutral', 'options': {'initPopulation': 5, 'type': node.config.type}}
                    );
                });
 
                this.pathManager.all().forEach(path => {
                    level.paths.push(
                        {'node1': path.origenNode.id, 'node2': path.destineNode.id},
                    );                
                });
            
                console.log(console.log(JSON.stringify(level)));
            });

        // Controles
        if (this.input.keyboard) {
            this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ZERO).on('down', () => { this.keyValueStored += '0';});
            this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ONE).on('down', () => { this.keyValueStored += '1';});
            this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.TWO).on('down', () => { this.keyValueStored += '2';});
            this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.THREE).on('down', () => { this.keyValueStored += '3';});
            this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.FOUR).on('down', () => { this.keyValueStored += '4';});
            this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.FIVE).on('down', () => { this.keyValueStored += '5';});
            this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SIX).on('down', () => { this.keyValueStored += '6';});
            this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SEVEN).on('down', () => { this.keyValueStored += '7';});
            this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.EIGHT).on('down', () => { this.keyValueStored += '8';});
            this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.NINE).on('down', () => { this.keyValueStored += '9';});
            this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ENTER).on('down', () => {

                console.log(this.keyValueStored);
                this.pathValues.push(this.keyValueStored);

                if(this.pathValues.length == 2) {
                    console.log('create path');
                    try {
                        const node1 = this.nodeManager.byId(this.pathValues[0]);
                        const node2 = this.nodeManager.byId(this.pathValues[1]);
                        
                        this.pathManager.add(node1, node2, []);
                        this.pathManager.searchPath(node1, node2)?.create();
                        this.children.sendToBack(<GameObjects.GameObject>this.bg);
                    } catch (_error) {
                        console.log('error al crear path');
                    }
                    this.pathValues = [];
                }

                this.keyValueStored = ''; 
            });
        }
    }

    update() {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
    }
}